import snakeCase from 'lodash/snakeCase';

export const sizeWithUnitsPerCarton = (size = '', unitsPerCtn = 1, includeBracket = true) =>
  `${snakeCase(size)}${unitsPerCtn ? ` ${includeBracket ? '(' : ''}${unitsPerCtn} pack${includeBracket ? ')' : ''}` : ''}`;

export const sizeWithoutUnitsPerCarton = (string) => string.replace(/\s*\(.*?\)\s*/g, '');
